export const isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }: HTMLElement): boolean => {
    return scrollHeight > clientHeight || scrollWidth > clientWidth;
  }